export type ProductType = 'junior_app' | 'senior_app';

export enum Feature {
  AllApps,
  ParentReport,
  ManyChildren,
  ExtraArticles,
}
